import React from "react";
import "./TextField.css";

interface TextFieldProps {
  label: string;
  name: string;
  value?: string;
  onChange: (name: string, value: string) => void;
  placeholder?: string;
  type?: string;
  disabled?: boolean,
  isFullWidth?: boolean
  error?: boolean;
}

const TextField: React.FC<TextFieldProps> = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  type = "text",
  disabled,
  isFullWidth,
  error,
}) => {
  return (
    <div className={`text-input-container ${isFullWidth ? "full-width" : ""}`}>
      <p className="text-input-label">{label}</p>
      <input
        className={`text-field ${error ? "error-field" : ""}`}
        disabled={disabled}
        type={type}
        name={name}
        id={name}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(name, e.target.value)}
      />
    </div>
  )
};

export default TextField;
